import { useEffect, useState } from 'react';
import { getShortEpg, type XtreamCredentials } from '../api/xtreamClient';
import type { XtreamEpgListing } from '../types/xtream';
import {
  pickCurrentEpgListing,
  pickNextEpgListing,
  SHORT_EPG_FETCH_LIMIT,
} from '../utils/epg';

export function useShortEpgNow(
  creds: XtreamCredentials | null | undefined,
  streamId: number | null | undefined,
) {
  const [now, setNow] = useState<XtreamEpgListing | null>(null);
  const [next, setNext] = useState<XtreamEpgListing | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!creds || streamId == null) {
      setNow(null);
      setNext(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    getShortEpg(creds, streamId, SHORT_EPG_FETCH_LIMIT)
      .then((data) => {
        if (cancelled) return;
        const list = data.epg_listings ?? [];
        const current = pickCurrentEpgListing(list);
        setNow(current);
        setNext(pickNextEpgListing(list, current));
      })
      .catch(() => {
        if (!cancelled) {
          setNow(null);
          setNext(null);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [creds, streamId]);

  return { now, next, loading };
}
